import * as ko from "knockout";
import {ITableDef} from "./index";

export class AllCheckbox<T> {
    // TODO simplify constructor with a single dictionary parameter
    constructor(
        private getPageData: () => T[],
        public selected: ITableDef<T>['selected'],
        private validate: ((obj: T) => boolean) = (obj: T) => true,
        public isEnabled: KnockoutComputed<boolean> = ko.pureComputed(() => true)
    ) {
    }

    public isChecked(): boolean {
        return this.getPageData()
            .filter(o => this.validate(o))
            .every(o => this.isItemChecked(o))
    }

    private isItemChecked(obj: T): boolean {
        return !!this._getSelected(obj)
    }

    public isIndeterminate(): boolean {
        if (this.isChecked()) {
            return false
        }
        const numChecked = this.getPageData()
            .filter(o => this.isItemChecked(o))
            .filter(o => this.validate(o))
            .length
        const numTotal = this.getPageData()
            .filter(o => this.validate(o))
            .length
        return !(numChecked == 0 || numChecked == numTotal);
    }

    public toggle() {
        if (!this.selected) {
            return true;
        }
        if (this.isChecked()) {
            const toBeRemoved = this.getPageData().map(o => this._getSelected(o)).filter((o): o is T => o != null)
            this.selected.removeAll(toBeRemoved)
        } else {
            const toBeAdded = this.getPageData()
                .filter(o => !this._getSelected(o))
                .filter(o => this.validate(o) ?? true)
            this.selected.push(...toBeAdded)
        }
        return true
    }

    private _getSelected(obj: T): T | undefined {
        return this.selected?.().find(o => (o as any).id == (obj as any).id)
    }

}